/**
 * Port vocabulary for the Home Assistant flow graph (see graphPorts.js for
 * the rules). Data flows in from Home Assistant on the left of the plate and
 * out to Home Assistant on the right:
 *
 *   Entity ─ha-entity▶ Binding ─ha-value▶ (UI object) ─object▶ Trigger ─ha-run▶ Condition ─ha-branch▶ Action ─ha-target▶ Entity
 *          └ha-entity▶ (UI object: Primary Entity)                       └─────ha-run──────────────▶ Action
 *   Entity ─ha-entity▶ Switch ─ha-case▶ Binding  (the binding applies in that case only)
 *   Entity ─ha-entity▶ Trigger                   (a state trigger)
 *
 * An entity node takes the actions that act on it on its input and gives its
 * state to bindings and objects on its output, so one node can be both.
 */
export { isPortCompatible } from '../graphPorts.js'

export const HASS_PORT_KIND = Object.freeze({
    // A Home Assistant entity: feeds a binding or a UI object (its Primary Entity).
    ENTITY: 'ha-entity',
    // A bound property value, from a binding into a UI object.
    VALUE: 'ha-value',
    // The events of a UI object.
    OBJECT: 'object',
    // A trigger running its actions and condition branches.
    RUN: 'ha-run',
    // A condition branch running its actions.
    BRANCH: 'ha-branch',
    // An action acting on an entity: its target.
    TARGET: 'ha-target',
    // A switch case gating a binding.
    CASE: 'ha-case',
})

// Implicit input of a UI object: its Primary Entity and its property bindings.
export const HASS_OBJECT_IN_PORT = Object.freeze({
    id: 'in', label: 'Entity / bindings', accepts: [HASS_PORT_KIND.ENTITY, HASS_PORT_KIND.VALUE],
})

// Implicit output of a UI object whose schema declares events.
export const HASS_OBJECT_EVENTS_PORT = Object.freeze({ id: 'events', label: 'Events', provides: HASS_PORT_KIND.OBJECT })
